import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const ScheduledReportsPanel = ({ schedules = [], onAddSchedule, onDeleteSchedule }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [newSchedule, setNewSchedule] = useState({
    reportType: 'monthly_performance',
    frequency: 'monthly',
    recipients: '',
    nextRun: ''
  });

  const defaultSchedules = [
    {
      id: 1,
      name: 'تقرير الأداء الشهري',
      frequency: 'شهرياً',
      nextRun: '٢٠٢٦/٠٢/٠١',
      recipients: 'admin@company.com',
      status: 'active'
    },
    {
      id: 2,
      name: 'تحليل العملاء الأسبوعي',
      frequency: 'أسبوعياً',
      nextRun: '٢٠٢٦/٠١/١٣',
      recipients: 'manager@company.com',
      status: 'active'
    },
    {
      id: 3,
      name: 'تقرير الإيرادات الربع سنوي',
      frequency: 'ربع سنوي',
      nextRun: '٢٠٢٦/٠٤/٠١',
      recipients: 'finance@company.com',
      status: 'active'
    }
  ];

  const schedulesList = schedules?.length > 0 ? schedules : defaultSchedules;

  const reportTypeOptions = [
    { value: 'monthly_performance', label: 'تقرير الأداء الشهري' },
    { value: 'client_analysis', label: 'تحليل العملاء' },
    { value: 'revenue_report', label: 'تقرير الإيرادات' },
    { value: 'staff_productivity', label: 'إنتاجية الموظفين' }
  ];

  const frequencyOptions = [
    { value: 'daily', label: 'يومياً' },
    { value: 'weekly', label: 'أسبوعياً' },
    { value: 'monthly', label: 'شهرياً' },
    { value: 'quarterly', label: 'ربع سنوي' }
  ];

  const handleAddSchedule = () => {
    if (onAddSchedule) {
      onAddSchedule(newSchedule);
    }
    setIsAdding(false);
    setNewSchedule({
      reportType: 'monthly_performance',
      frequency: 'monthly',
      recipients: '',
      nextRun: ''
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="Clock" size={20} />
          التقارير المجدولة
        </h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsAdding(!isAdding)}
          iconName={isAdding ? "X" : "Plus"}
          iconPosition="right"
        >
          {isAdding ? 'إلغاء' : 'جديد'}
        </Button>
      </div>
      {isAdding && (
        <div className="mb-4 p-4 bg-muted rounded-lg space-y-3">
          <Select
            label="نوع التقرير"
            options={reportTypeOptions}
            value={newSchedule?.reportType}
            onChange={(value) => setNewSchedule(prev => ({ ...prev, reportType: value }))}
          />
          <Select
            label="التكرار"
            options={frequencyOptions}
            value={newSchedule?.frequency}
            onChange={(value) => setNewSchedule(prev => ({ ...prev, frequency: value }))}
          />
          <Input
            label="المستلمون (البريد الإلكتروني)"
            type="email"
            placeholder="email@example.com"
            value={newSchedule?.recipients}
            onChange={(e) => setNewSchedule(prev => ({ ...prev, recipients: e?.target?.value }))}
          />
          <Input
            label="التشغيل التالي"
            type="date"
            value={newSchedule?.nextRun}
            onChange={(e) => setNewSchedule(prev => ({ ...prev, nextRun: e?.target?.value }))}
          />
          <Button
            variant="default"
            fullWidth
            onClick={handleAddSchedule}
            iconName="Check"
            iconPosition="right"
          >
            إضافة جدولة
          </Button>
        </div>
      )}
      <div className="space-y-2 max-h-80 overflow-y-auto">
        {schedulesList?.map((schedule) => (
          <div
            key={schedule?.id}
            className="p-3 rounded-lg border border-border hover:bg-muted transition-all duration-250"
          >
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1">
                <h4 className="text-sm font-medium text-foreground mb-1">{schedule?.name}</h4>
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="RefreshCw" size={12} />
                    <span>{schedule?.frequency}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Calendar" size={12} />
                    <span>{schedule?.nextRun}</span>
                  </div>
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onDeleteSchedule && onDeleteSchedule(schedule?.id)}
                iconName="Trash2"
                iconSize={16}
              />
            </div>
            <div className="flex items-center gap-2 text-xs">
              <Icon name="Mail" size={12} color="var(--color-muted-foreground)" />
              <span className="text-muted-foreground truncate">{schedule?.recipients}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduledReportsPanel;